import styles from './RadioButton.module.scss';

export default function RadioButtonComponent({ name, option, value, handleChange, children }) {
    const onChange = (e) => {
        handleChange(e.target.value);
    };
    return (
        <label className={styles.redlRadioButton}>
            <input type="radio" id={name} name={name} value={option} checked={value === option}
                   onChange={onChange}></input>
            <span className={styles.redlRadioButtonText}>
                {children}
            </span>
            <div className={styles.redlRadioButtonSelected}></div>
        </label>
    );
}